import { FromViewState } from 'owa-mail-compose-store';
import FindControlViewState, {
    FindResultType,
    DirectorySearchType,
} from 'owa-recipient-types/lib/types/FindControlViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'initializeFromWellFindControlViewState',
    function initializeFromWellFindControlViewState(viewState: FromViewState) {
        const findControlViewState: FindControlViewState = {
            queryString: '',
            findPeopleFeedbackManager: null,
            findResultSet: [],
            findResultType: FindResultType.None,
            isSearching: false,
            directorySearchType: DirectorySearchType.None,
            numberOfCacheResults: 0,
        };

        viewState.fromWellFindControlViewState = findControlViewState;
    }
);
